export const contractorAttitudestTypes = [
    {
        label: 'خوش برخورد',
        value: 'GOOD_TEMPERED_IN_COMMUNICATION'
    },
    {
        label: 'خلاق و ایده پرداز',
        value: 'GOOD_IMAGINATION',
    },
    {
        label: 'قیمت منصفانه',
        value: 'JUSTIFIED_PRICE',
    },
    {
        label: 'مسلط در مشاوره',
        value: 'EXPERT_CONSULTANTS',
    },
    {
        label: 'قابل اعتماد',
        value: 'TRUSTY',
    },
    {
        label: 'تحویل به موقع و بدون تاخیر',
        value: 'ON_TIME_DELIVERY_ATTITUDE',
    },
    {
        label: 'با حوصله و پاسخگو',
        value: 'GOOD_TEMPERED_IN_Q_AND_A',
    },
    {
        label: 'دقت و کیفیت بالای انجام کار',
        value: 'GOOD_WORK_QUALITY',
    },
]

export const sortTypes = [
    {
        label: 'پیشنهاد کاربران',
        value: 'usersRecommendation',
    },
    {
        label: 'بیشترین تجربه کاری',
        value: 'workExperience',
    },
    {
        label: 'بیشترین تعداد پروژه',
        value: 'doneProjectsCount',
    },
    {
        label: 'بیشترین امتیاز',
        value: 'totalCommentsStar',
    },
    {
        label: 'بیشترین نظرات',
        value: 'totalCommentsCount',
    },
]

export const contractorLevels = [
    {
        value: 1,
        label: 'متخصص ویژه',
    },
    {
        value: 2,
        label: 'متخصص عادی',
    },
    {
        value: 3,
        label: 'متخصص مقدماتی'
    },
]